/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MonthPanel from '../month/monthPanel.js';
import YearPanel from '../year/yearPanel.js';
import DecadePanel from '../decade/decadePanel.js';
var __vue_script__ = {
  name: 'HeaderPanel',
  components: {
    MonthPanel: MonthPanel,
    YearPanel: YearPanel,
    DecadePanel: DecadePanel
  },
  props: {
    prefixCls: String,
    mode: String,
    value: Date,
    locale: Object,
    yearFrom: String,
    disabledMonth: {
      type: Function,
      default: undefined
    },
    disabledYear: {
      type: Function,
      default: undefined
    },
    monthNav: {
      type: Object,
      default: function _default() {
        return {
          prev: true,
          next: true
        };
      }
    },
    yearNav: {
      type: Object,
      default: function _default() {
        return {
          prev: true,
          next: true
        };
      }
    }
  },
  computed: {
    isMonth: function isMonth() {
      return this.mode === 'month';
    },
    isYear: function isYear() {
      return this.mode === 'year';
    },
    isDecade: function isDecade() {
      return this.mode === 'decade';
    }
  },
  methods: {
    goNextPanel: function goNextPanel(value, next, originMode) {
      this.$emit('on-select', value, next, originMode);
    },
    onMonthSelect: function onMonthSelect(value) {
      this.goNextPanel(value, 'date', 'month');
    },
    onYearSelect: function onYearSelect(value) {
      var yearFrom = this.yearFrom,
          goNextPanel = this.goNextPanel;
      goNextPanel(value, yearFrom, 'year');
    },
    onDecadeSelect: function onDecadeSelect(value) {
      this.goNextPanel(value, 'year', 'descade');
    },
    onShowYearPanel: function onShowYearPanel(from) {
      this.$emit('on-show-year-panel', from);
    },
    onShowDecadePanel: function onShowDecadePanel() {
      this.$emit('on-show-decade-panel');
    },
    onMonthValueChange: function onMonthValueChange(value) {
      this.$emit('month-value-change', value);
    },
    onYearValueChange: function onYearValueChange(value) {
      this.$emit('year-value-change', value);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.isMonth ? _c('month-panel', {
    attrs: {
      "root-prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "disabled-month": _vm.disabledMonth,
      "value": _vm.value,
      "month-nav": _vm.monthNav
    },
    on: {
      "on-show-year-panel": _vm.onShowYearPanel,
      "on-change": _vm.onMonthValueChange,
      "on-select": _vm.onMonthSelect
    }
  }) : _vm._e(), _vm._v(" "), _vm.isYear ? _c('year-panel', {
    attrs: {
      "root-prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "value": _vm.value,
      "year-nav": _vm.yearNav,
      "disabled-year": _vm.disabledYear
    },
    on: {
      "on-show-decade-panel": _vm.onShowDecadePanel,
      "on-change": _vm.onYearValueChange,
      "on-select": _vm.onYearSelect
    }
  }) : _vm._e(), _vm._v(" "), _vm.isDecade ? _c('decade-panel', {
    attrs: {
      "root-prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "value": _vm.value
    },
    on: {
      "on-select": _vm.onDecadeSelect
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "headerPanel.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);